import React, { Component } from 'react';

import TeachersGrid from './../component/TeachersGrid';
import MySelect from "./../component/select";

class Deeplearn extends Component{


  handelSelect = (e) => {
    if(e.name === 'subject') this.props.setSubject(e.value);
    if(e.name === 'class') this.props.setClass(e.value);
  };
  componentDidMount() {
    window.scrollTo(0, 0,);
    this.props.setSubject(null);
    this.props.setClass(null);
  }
  componentWillUnmount() {

  }
  render() {
    return (
      <div className="elementary">
        <img className="img"  src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/custom-pages/im-ognakan/way/elem.cut.jpg" alt=""/>
        <div className="intro">
          <h1 className="header text-center">Տարրական օղակի դասընթացներ</h1>
          <p>
            Սիրելի՛ ծնողներ, ձեզ ենք ներկայացնում մի ծրագիր, որի շրջանակներում յուրաքանչյուր աշակերտ
            հնարավորություն կստանա իր գիտելիքները կառուցելու ճանապարհին ուղղորդվել այնպիսի մասնագետների
            կողմից, ովքեր լավագույններից են Հայաստանում։ Եվ այս ամենը օնլայն հարթակում՝ առանց տնից դուրս
            գալու։ Ծրագրից օգտվելու արդյունքում ձեր երեխան կունենա բարձր առաջադիմություն, ինքնուրույնություն
            և վստահություն սեփական ուժերի նկատմամբ։
          </p>
        </div>

        <div className="m-60"></div>
        <h3 className="header text-center choos-sub-class">Ընտրեք դասարանն ու առարկան</h3>

        <div className="col-sm-3 "></div>
        <div className="col-sm-3 ">
          <MySelect
            name="subject"
            onChange={this.handelSelect}
            default="Առարկա"
            options={[
              "Մայրենի",
              "Մաթեմատիկա",
              "Անգլերեն ",
              "Ռուսաց լեզու",
            ]}
          />
        </div>
        <div className="col-sm-3 ">
          <MySelect
            name="class"
            onChange={this.handelSelect}
            default="Դասարան"
            options={["1", "2", "3", "4"]}
          />
        </div>
        <div className="col-sm-3"></div>
        <div className="polaceholder"></div>



        {(this.props.classNumber && this.props.subject) ?
          <TeachersGrid
            classNumber={this.props.classNumber}
            subject={this.props.subject}
            setTeacher={this.props.setTeacher}
          /> :
          <div></div>}
      </div>
    )
  }
}

export default Deeplearn;